export default "__VITE_ASSET__Cvpxz1F1__"